import React from "react";
import "./OurTeam.css";

interface TeamMember {
  name: string;
  position: string;
  phone: string;
  email: string;
}

const teamMembers: TeamMember[] = [
  {
    name: "Crețu Veronica",
    position: "Director General",
    phone: "0722306623",
    email: "veronica.c@neks.ro",
  },
  {
    name: "Coconașu Gheorghe",
    position: "Director Comercial",
    phone: "0720533641",
    email: "gheorghe.c@neks.ro",
  },
  {
    name: "Raus Vasile",
    position: "Director Logistică",
    phone: "0737849363",
    email: "raus.v@neks.ro",
  },
  {
    name: "Cindescu Claudiu",
    position: "Director Vânzări",
    phone: "0720205914",
    email: "claudiu.c@neks.ro",
  },
  {
    name: "Crețu Eduard",
    position: "Agent Vânzări",
    phone: "0735482744",
    email: "cretueduard577@gmail.com",
  },
  {
    name: "Nenciu Liviu",
    position: "Agent Vânzări",
    phone: "0726871512",
    email: "",
  },
  {
    name: "Alina Chiriță",
    position: "Agent Vânzări",
    phone: "0790230073",
    email: "",
  },
];

const OurTeam: React.FC = () => {
  return (
    <div className="our-team-container">
      <h2 className="team-title">Echipa noastră</h2>
      <div className="team-grid">
        {teamMembers.map((member, index) => (
          <div key={index} className="team-card">
            <h3 className="team-name">{member.name}</h3>
            <p className="team-position">{member.position}</p>
            <p className="team-contact">
              <a href={`tel:+4${member.phone}`} className="team-link">{member.phone}</a>
            </p>
            <p className="team-contact">
              <a href={`mailto:${member.email}`} className="team-link">{member.email}</a>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurTeam;
